import MobileObjectProps from './MobileObjectProps'

export default MobileObjectProps